import React from "react";
import { Box, Chip } from "@mui/material";

export function SmartWrapChips({
                                  selected,
                                  getLabel,
                              }: {
    selected: string[];
    getLabel: (id: string) => string;
}) {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [rows, setRows] = React.useState<string[][]>([]);
    const [scrollingRows, setScrollingRows] = React.useState<Set<number>>(new Set());

    React.useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const chipEls = Array.from(container.querySelectorAll(".chip-measure"));
        const containerWidth = container.clientWidth;

        const newRows: string[][] = [];
        const newScrollingRows = new Set<number>();

        let currentRow: string[] = [];
        let rowWidth = 0;

        chipEls.forEach((chipEl, i) => {
            const chipWidth = chipEl.getBoundingClientRect().width;
            const remaining = containerWidth - rowWidth;

            if (chipWidth > containerWidth) {
                if (currentRow.length > 0) {
                    newRows.push(currentRow);
                    currentRow = [];
                    rowWidth = 0;
                }
                newRows.push([selected[i]]);
                newScrollingRows.add(newRows.length - 1);
            } else if (chipWidth > remaining) {
                const overflowRatio = (chipWidth - remaining) / chipWidth;
                if (overflowRatio > 0.1) {
                    newRows.push(currentRow);
                    currentRow = [selected[i]];
                    rowWidth = chipWidth;
                } else {
                    currentRow.push(selected[i]);
                    rowWidth += chipWidth;
                }
            } else {
                currentRow.push(selected[i]);
                rowWidth += chipWidth;
            }
        });

        if (currentRow.length > 0) newRows.push(currentRow);

        setRows(newRows);
        setScrollingRows(newScrollingRows);
    }, [selected]);

    return (
        <Box ref={containerRef} sx={{ width: "100%" }}>
            <Box sx={{ visibility: "hidden", position: "absolute", height: 0, overflow: "hidden" }}>
                {selected.map((id, index) => (
                    <Chip
                        key={`measure-${index}`}
                        className="chip-measure"
                        label={getLabel(id)}
                        sx={{
                            margin: "2px",
                            whiteSpace: "nowrap",
                            height: "30px",
                            fontSize: "0.85rem",
                        }}
                    />
                ))}
            </Box>

            {rows.map((row, rowIndex) => (
                <Box
                    key={rowIndex}
                    sx={{
                        display: "flex",
                        flexWrap: "nowrap",
                        gap: 1,
                        marginBottom: "4px",
                        overflowX: scrollingRows.has(rowIndex) ? "auto" : "visible",
                        paddingBottom: scrollingRows.has(rowIndex) ? "2px" : 0,
                        "&::-webkit-scrollbar": {
                            height: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#ccc",
                            borderRadius: "4px",
                        },
                    }}
                >
                    {row.map((id, chipIndex) => (
                        <Chip
                            key={`${rowIndex}-${chipIndex}`}
                            label={getLabel(id)}
                            sx={{
                                whiteSpace: "nowrap",
                                height: "30px",
                                fontSize: "0.85rem",
                            }}
                        />
                    ))}
                </Box>
            ))}
        </Box>
    );
}
